module.exports = function makeIcon(img, borderColor, fillColor) {
	fillColor = fillColor || '#FFF';
	var cnv = document.createElement('canvas');
	var ctx = cnv.getContext('2d');
	cnv.width = cnv.height = 44;

	ctx.beginPath();
	ctx.shadowBlur = 3;
	ctx.shadowColor = 'rgba(0,0,0,1)';
	ctx.fillStyle = 'rgba(0,0,0,0.35)';
	ctx.arc(22, 24, 18, 0, Math.PI * 2);
	ctx.fill();

	ctx.shadowBlur = 0;

	ctx.beginPath();
	ctx.fillStyle = borderColor;
	ctx.arc(22, 22, 19, 0, Math.PI * 2);
	ctx.fill();

	ctx.beginPath();
	ctx.fillStyle = fillColor;
	ctx.arc(22, 22, 16, 0, Math.PI * 2);
	ctx.fill();

	ctx.drawImage(img, 22 - img.width/2, 22 - img.height/2);

	return cnv.toDataURL();
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/makeIcon.js
 **/